import React from 'react';

import { withIntercomProps } from '../../components/chatbot';
import { TimeZoneProvider } from '../../components/date_formatting/timezone_context';
import { useCurrentUser } from '../../lib/authorization';
import { Workspace } from '../components/workspace';

type Props = {
  onSignout(): Promise<void>;
};

export const WorkspaceContainer: React.FC<Props> = ({ onSignout }) => {
  const currentUser = useCurrentUser();

  return <TimeZoneProvider>{withIntercomProps(currentUser, <Workspace onSignout={onSignout} />)}</TimeZoneProvider>;
};
